import { chakra } from '@plurall/elo-v3';

import {
  navActionButtonRecipe,
  navCenterRecipe,
  navEndRecipe,
  navRootRecipe,
  navStartRecipe,
  navTitleRecipe,
  topbarRecipe,
} from './global-navigation-recipe';

export const TopbarFactory = chakra('header', topbarRecipe);

export const NavRootFactory = chakra('div', navRootRecipe);

export const NavStartFactory = chakra('div', navStartRecipe);
export const NavEndFactory = chakra('div', navEndRecipe);
export const NavCenterFactory = chakra('div', navCenterRecipe);

export const NavTitleFactory = chakra('span', navTitleRecipe);

export const NavActionButtonFactory = chakra('button', navActionButtonRecipe);
